/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { IChannelLogoServiceRepository } from '../interfaces';

export class ChannelLogoServiceRepositoryImpl implements IChannelLogoServiceRepository {
    private readonly DEFAULT_SCREEN_HEIGHT: number = 1080;

    private readonly DEFAULT_SCREEN_WIDTH: number = 1920;

    private mChannelLogoBaseUrl: string;

    private mLogoSize: string;

    public constructor(baseUrl: string, width: number = 168, height: number = 48) {
        this.mChannelLogoBaseUrl = `${baseUrl}/logos`;
        const { scaledWidth, scaledHeight } = this.getScaledLogoSize(width, height);
        this.mLogoSize = `${scaledWidth}x${scaledHeight}`;
    }

    /**
     * Scales the logo width and height according to the current 16:9 screen resolution.
     * The default logo size is for 1920x1080 screens.
     * @param width - The default logo width (for 1920px).
     * @param height - The default logo height (for 1080px).
     * @returns An object containing the scaled width and height.
     */
    private getScaledLogoSize(
        width: number,
        height: number,
    ): { scaledWidth: number; scaledHeight: number } {
        const screenWidth =
            typeof window !== 'undefined' ? window.innerWidth : this.DEFAULT_SCREEN_WIDTH;
        const screenHeight =
            typeof window !== 'undefined' ? window.innerHeight : this.DEFAULT_SCREEN_HEIGHT;
        const scaledWidth = Math.round((screenWidth / this.DEFAULT_SCREEN_WIDTH) * width);
        const scaledHeight = Math.round((screenHeight / this.DEFAULT_SCREEN_HEIGHT) * height);
        return { scaledWidth, scaledHeight };
    }

    /**
     * @inheritdoc
     */
    public getChannelLogoUrl(logoIndex: number): string {
        return `${this.mChannelLogoBaseUrl}/${this.mLogoSize}/${logoIndex - 65536}.png`;
    }
}
